import { NextSeo } from 'next-seo';
import { FC } from 'react';
import { StructuredData } from './StructuredData';

export interface SEOProps {
  title: string;
  description: string;
  canonicalUrl: string;
  breadcrumbs: {
    position: number;
    name: string;
    item: string;
  }[];
  blogPost?: {
    title: string;
    description: string;
    author: string;
    datePublished: string;
    image: string;
  };
  localBusiness?: {
    name: string;
    address: {
      streetAddress: string;
      addressLocality: string;
      addressRegion: string;
      postalCode: string;
    };
    telephone: string;
    rating?: number;
    reviewCount?: number;
    geo?: {
      latitude: number;
      longitude: number;
    };
  };
  faq?: Array<{
    question: string;
    answer: string;
  }>;
  blogSchema?: {
    "@context": string;
    "@type": string;
    name: string;
    description: string;
    url: string;
    blogPost: Array<{
      "@type": string;
      headline: string;
      description: string;
      datePublished: string;
      image: string;
      url: string;
      keywords: string;
    }>;
  };
}

export const SEO: FC<SEOProps> = ({
  title = 'Mobile Mechanics Near You | MobileMechanicsLocator.com',
  description = 'Find trusted mobile mechanics in your area. Book reliable auto repair services that come to you.',
  canonicalUrl,
  breadcrumbs,
  localBusiness,
  faq,
  blogSchema
}) => {
  const baseUrl = 'https://mobilemechanicslocator.com';
  const fullCanonicalUrl = canonicalUrl ? `${baseUrl}${canonicalUrl}` : baseUrl;

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={fullCanonicalUrl}
        openGraph={{
          url: fullCanonicalUrl,
          title,
          description,
          site_name: 'Mobile Mechanics Locator',
          type: 'website',
        }}
        twitter={{
          cardType: 'summary_large_image',
          site: '@mobilemechlocator',
        }}
      />
      
      {/* Inject structured data */}
      {(breadcrumbs || localBusiness || faq || blogSchema) && (
        <StructuredData
          breadcrumbs={breadcrumbs}
          localBusiness={localBusiness}
          faq={faq}
          blogSchema={blogSchema}
        />
      )}
    </>
  );
}; 